import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  isNodeEmpty,
  Placeholder,
  QUOTE_DEFINITIONS,
  QUOTE_SOURCE_DEFINITIONS,
  QUOTE_TEXT_DEFINITIONS,
} from '@xing-com/content-editor-plugin-helpers';

import { QUOTE_TAG_NAME, SOURCE_TAG_NAME } from './constants';
import styles from './Quote.css';
import { QuotesIcon } from './QuotesIcon';

const Quote = ({
  className,
  QUOTE_TAG = QUOTE_TAG_NAME,
  SOURCE_TAG = SOURCE_TAG_NAME,
  ...attributes
}) => {
  const RenderLeaf = ({
    children,
    element,
    attributes: elementAttributes,
  } = {}) => {
    // quote wrapper element
    if (element.type === QUOTE_DEFINITIONS.type) {
      return (
        <div {...attributes} className={cx(className, styles.quote)}>
          <QuotesIcon
            size={86}
            className={styles.icon}
            contentEditable={false}
          />
          {children}
        </div>
      );
    }
    // quote-text element
    if (element.type === QUOTE_TEXT_DEFINITIONS.type) {
      const { placeholder, ...restOfAttributes } = attributes;
      if (placeholder && isNodeEmpty(element)) {
        return (
          <QUOTE_TAG
            data-editor-plugin={QUOTE_DEFINITIONS.type}
            {...restOfAttributes}
            {...elementAttributes}
          >
            {Placeholder(children, null, placeholder)}
          </QUOTE_TAG>
        );
      } else {
        return (
          <QUOTE_TAG
            data-editor-plugin={QUOTE_DEFINITIONS.type}
            {...restOfAttributes}
            {...elementAttributes}
          >
            {children}
          </QUOTE_TAG>
        );
      }
    }
    // quote-source element
    if (element.type === QUOTE_SOURCE_DEFINITIONS.type) {
      const { sourceplaceholder, ...restOfAttributes } = attributes;

      if (sourceplaceholder && isNodeEmpty(element)) {
        return (
          <SOURCE_TAG
            data-editor-plugin={QUOTE_SOURCE_DEFINITIONS.type}
            {...restOfAttributes}
            {...elementAttributes}
          >
            {Placeholder(children, null, sourceplaceholder)}
          </SOURCE_TAG>
        );
      } else {
        return (
          <SOURCE_TAG
            data-editor-plugin={QUOTE_SOURCE_DEFINITIONS.type}
            {...restOfAttributes}
            {...elementAttributes}
          >
            {children}
          </SOURCE_TAG>
        );
      }
    }
  };
  return RenderLeaf;
};

Quote.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  QUOTE_TAG: PropTypes.node,
  SOURCE_TAG: PropTypes.node,
  sourceplaceholder: PropTypes.string,
};

export { Quote };
